import request from './request';
import URLS from '../configurations/urls';
import Api from './Api';

class ArbiterApi extends Api{

    static getReasonCodes(params = {}){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_REASON_CODES}`;
        options.params = params;
        return request.get(options);
    }

    static updateReasonCode(id, data){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_REASON_CODES}/${id}`;
        options.data = data;
        return request.patch(options);
    }
    static createReasonCode(data){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += URLS.ARBITER_API_REASON_CODES;
        options.data = data;
        return request.post(options);
    }
    static getReasonCodesByCategory(category){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_DISPUTES_CATEGORIES}/${category}/reasons`;
        options.params = {};
        return request.get(options);
    }

    static getTransactionGroups(){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_TRANSACTIONS_GROUPS}`;
        options.params = {};
        return request.get(options);
    }

    static getPaginatedTransactionGroups(params = {}){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_TRANSACTION_GROUPS}`;
        options.params = params;
        return request.get(options);
    }
     static updateTransactionGroup(id, data){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_TRANSACTION_GROUPS}/${id}`;
        options.data = data;
        return request.patch(options);
    }
    static createTransactionGroup(data){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += URLS.ARBITER_API_TRANSACTION_GROUPS;
        options.data = data;
        return request.post(options);
    }

    static getDisputeRegions(params = {}){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_DISPUTE_REGIONS}`;
        options.params = params;
        return request.get(options);
    }
    static updateDisputeRegion(id, data){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_DISPUTE_REGIONS}/${id}`;
        options.data = data;
        return request.patch(options);
    }
    static createDisputeRegion(data){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += URLS.ARBITER_API_DISPUTE_REGIONS;
        options.data = data;
        return request.post(options);
    }

     static getTransactionTypes(params = {}){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_TRANSACTION_TYPE}`;
        options.params = params;
        return request.get(options);
    }
    static updateTransactionType(id, data){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_TRANSACTION_TYPE}/${id}`;
        options.data = data;
        return request.patch(options);
    }
    static createTransactionType(data){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += URLS.ARBITER_API_TRANSACTION_TYPE;
        options.data = data;
        return request.post(options);
    }


    static getDisputeCategories(){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_DISPUTES_CATEGORIES}`;
        options.params = {};
        return request.get(options);
    }

    static getTransactionTimelines(params = {}){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_TRANSACTION_TIMELINES}`;
        options.params = params;
        return request.get(options);
    }
    
    static createTransactionTimeline(data){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += URLS.ARBITER_API_TRANSACTION_TIMELINES;
        options.data = data;
        return request.post(options);
    }

    static updateTransactionTimeline(id, data){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_TRANSACTION_TIMELINES}/${id}`;
        options.data = data;
        return request.patch(options);
    }

     static deleteTransactionTimeline(id){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_TRANSACTION_TIMELINES}/${id}`;
        return request.delete(options);
    }

     static getDisputeTimelines(params = {}){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_DISPUTE_TIMELINES}`;
        options.params = params;
        return request.get(options);
    }
    
    static createDisputeTimeline(data){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += URLS.ARBITER_API_DISPUTE_TIMELINES;
        options.data = data;
        return request.post(options);
    }

    static updateDisputeTimeline(id, data){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_DISPUTE_TIMELINES}/${id}`;
        options.data = data;
        return request.patch(options);
    }

     static deleteDisputeTimeline(id){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_DISPUTE_TIMELINES}/${id}`;
        return request.delete(options);
    }

    
     static getMerchantDisputants(params = {}){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_MERCHANT_DISPUTANTS}`;
        options.params = params;
        return request.get(options);
    }
    
    static createMerchantDisputant(data){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += URLS.ARBITER_API_MERCHANT_DISPUTANTS;
        options.data = data;
        return request.post(options);
    }

     static deleteMerchantDisputant(id){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_MERCHANT_DISPUTANTS}/${id}`;
        return request.delete(options);
    }

}

export default ArbiterApi;


// WEBPACK FOOTER //
// ./src/api/ArbiterApi.js